// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View2_wrapper__2GuMd","topRow":"View2_topRow__2Gy1p","user":"View2_user__2nfXM","mainUser":"View2_mainUser__367HT","bottomRow":"View2_bottomRow__2bMij"};